.toggles {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px 0;
}

.toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.95rem;
  cursor: pointer;
  user-select: none;
  background-color: #dde5e2;
  color: #33413c;
  border: 1px solid #93aca3;
}
.toggle.active {
  background-color: #1d7a60;
  color: white;
  border-color: #1d7a60;
}

.label {
  line-height: 1.2;
}

:global(.dark) .toggle {
  background-color: #223431;
  color: #93a8a2;
  border-color: #3a544e;
}
:global(.dark) .toggle.active {
  background-color: #1d7a60;
  color: #eafff8;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRvZ2dsZXNGaWVsZC5zYXNzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0Usa0JBdEJpQjtFQXVCakI7RUFDQSxjQXhCaUI7OztBQTBCckI7RUFDRTs7O0FBR0E7RUFDRTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRSxrQkFuQ2U7RUFvQ2YiLCJzb3VyY2VzQ29udGVudCI6WyIkcGxhY2UtY29sb3I6ICMyYThcbiRwbGFjZS1jb2xvci1zdHJvbmc6ICMxZDdhNjBcblxuLnRvZ2dsZXNcbiAgZGlzcGxheTogZmxleFxuICBmbGV4LXdyYXA6IHdyYXBcbiAgZ2FwOiA4cHhcbiAgcGFkZGluZzogNHB4IDBcblxuLnRvZ2dsZVxuICBkaXNwbGF5OiBpbmxpbmUtZmxleFxuICBhbGlnbi1pdGVtczogY2VudGVyXG4gIGdhcDogOHB4XG4gIG1pbi1oZWlnaHQ6IDQwcHhcbiAgcGFkZGluZzogOHB4IDE2cHhcbiAgYm9yZGVyLXJhZGl1czogMjBweFxuICBmb250LXNpemU6IDAuOTVyZW1cbiAgY3Vyc29yOiBwb2ludGVyXG4gIHVzZXItc2VsZWN0OiBub25lXG4gIGJhY2tncm91bmQtY29sb3I6ICNkZGU1ZTJcbiAgY29sb3I6ICMzMzQxM2NcbiAgYm9yZGVyOiAxcHggc29saWQgIzkzYWNhM1xuICAmLmFjdGl2ZVxuICAgIGJhY2tncm91bmQtY29sb3I6ICRwbGFjZS1jb2xvci1zdHJvbmdcbiAgICBjb2xvcjogd2hpdGVcbiAgICBib3JkZXItY29sb3I6ICRwbGFjZS1jb2xvci1zdHJvbmdcblxuLmxhYmVsXG4gIGxpbmUtaGVpZ2h0OiAxLjJcblxuOmdsb2JhbCguZGFyaylcbiAgLnRvZ2dsZVxuICAgIGJhY2tncm91bmQtY29sb3I6ICMyMjM0MzFcbiAgICBjb2xvcjogIzkzYThhMlxuICAgIGJvcmRlci1jb2xvcjogIzNhNTQ0ZVxuICAgICYuYWN0aXZlXG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkcGxhY2UtY29sb3Itc3Ryb25nXG4gICAgICBjb2xvcjogI2VhZmZmOFxuIl19 */